import { articlePageQuery_articlePage_slugsByLocale } from '../../core-types';
import { BlockContent } from '../../components/BlockContent';
import { ArticleLayout } from './ArticleLayout';

const Article = ({
  data,
  appContent
}: {
  data:
    | {
        title: string;
        file: CORE_JSON | null;
        heading: string | null;
        intro: CORE_JSON | null;
        content: CORE_JSON | null;
        slugsByLocale: articlePageQuery_articlePage_slugsByLocale[] | null;
      }
    | undefined;
  appContent: boolean;
}) => {
  if (!data) {
    return null;
  }
  const { intro, content, file } = data;
  const heading = data.heading || data.title;
  return (
    <ArticleLayout
      appContent={appContent}
      heading={heading}
      intro={
        intro && <BlockContent blocks={intro} withoutAnchors={appContent} />
      }
      content={
        content && <BlockContent blocks={content} withoutAnchors={appContent} />
      }
      file={file || null}
    />
  );
};

export default Article;
